import type { InstallOnelinerProvider } from '../base.js';

/**
 * UTF-8 safe base64 encode that works in both Node 18+ and browsers.
 */
function toBase64Utf8(str: string): string {
  const bytes = new TextEncoder().encode(str);
  let binary = '';
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}

export class PowerShellInstallOneliner implements InstallOnelinerProvider {
  readonly id = 'powershell';
  readonly label = 'Windows';
  readonly sublabel = 'PowerShell';
  readonly sublabelCode = 'Set-Content';
  readonly nativeExtensions = ['.ps1', '.psm1', '.psd1'] as const;

  build(filename: string, content: string): string {
    const trimmed = content.replace(/\s+$/, '');
    const escapedName = filename.replace(/'/g, "''");

    // Single-quoted PS here-string preserves content verbatim, but its
    // terminator (`'@` on its own line) is fixed and cannot be renamed.
    // If the content would prematurely close it, fall back to base64.
    const hereStringSafe = !/^\s*'@\s*$/m.test(trimmed);
    if (hereStringSafe) {
      return `@'
${trimmed}
'@ | Set-Content -Path '${escapedName}' -Encoding utf8
Write-Host "Created ${filename} - run with: .\\${filename}"`;
    }

    const b64 = toBase64Utf8(trimmed);
    return `[System.Text.Encoding]::UTF8.GetString([Convert]::FromBase64String('${b64}')) | Set-Content -Path '${escapedName}' -Encoding utf8
Write-Host "Created ${filename} - run with: .\\${filename}"`;
  }
}
